import { render, staticRenderFns } from "./CustomLAbelType3.vue?vue&type=template&id=3a3e0fb7&"
import script from "./CustomLAbelType3.vue?vue&type=script&lang=js&"
export * from "./CustomLAbelType3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports